/* eslint-disable */
// Locales
import Locales from "@/views/Locales.vue";
import localesIndex from "@/components/locales/Index.vue";
import localesAdd from "@/components/locales/Add.vue";

//Middleware
import isLogin from "@/middleware/AuthMiddleware.js";

export default {
  path: "/locales",
  component: Locales,
  children:[
    {
      path:'/',
      component:localesIndex,
      name: "locales",
      meta:{
        parent: "locales",
        title: "Locales",
        navbar:true,
        middleware:[
          isLogin,
        ]
      },
    },
    {
      path:'add',
      component:localesAdd,
      name: 'locales.add',
      meta:{
        parent: "locales",
        title: "Add Locale",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    },
    {
      path:'edit/:id',
      component:localesAdd,
      name:"locales.edit",
      meta:{
        parent: "locales",
        title: "Add Locale",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    }
  ]
}